import React, { Fragment, useState, useContext, useEffect, useCallback } from 'react';
import "./Schedules.css";
import "../../../ui-styles/animations/ripple.css";
import "../../../ui-styles/buttons/ButtonFilled.css";
import "../../../ui-styles/buttons/ButtonTxt.css";
import { LangCtx } from "../../../lib/context";
// import Button from "../../../lib/ui/buttons/Button";

import BtmDeleteSlide from '../../../lib/ui/BtmDeleteSlider';
import BtmEditDeletSlider from '../../../lib/ui/BtmEditDeletSlider';
import CreateDays from "./createDays";
import { getSchedules, deleteAllSch } from "../../../actions/schedule";
import Loader from "../../../lib/ui/loader/Loader";
import ScheduleListItem from "./schedulesList";
import AddNewSchedule from "./addNewSchedule";
import { toast } from 'react-toastify';
import DisableDatesSlider from './DisableDatesSlider';
// import { registerLocale } from "react-datepicker";
// import es from 'date-fns/locale/es';
// registerLocale('es', es);
import {API} from 'aws-amplify';

const CreateSchedule = (props) => {
    const [loading, setLoading] = useState(false);
    const [shedule, setSchedule] = useState(null);
    const [addNew, setAddNew] = useState(false);
    const [slideED, setSlideED] = useState(false);
    const [slideD, setSlideD] = useState(false);
    const [openDD, setDD] = useState(false);
    const { l } = useContext(LangCtx);

    useEffect(() => {
        loadSchedule();
    }, []);

    const loadSchedule = useCallback(() => {
        setLoading(true);
        getSchedules().then(res => {
            setLoading(false);
            if (res && res.data) {
                let _data = {};
                for (let i = 0; i < res.data.length; i++) {
                    let item = res.data[i];
                    _data[item.groupId] ? _data[item.groupId].push(item) : _data[item.groupId] = [item];
                }
                setSchedule({ ..._data })
            } else {
                setSchedule({})
            }
        }).catch(err => {
            if(API.isCancel(err)) {
                console.log("API is canceled................");
            } else {
                setLoading(false);
            }
            console.log("err === ", err);
            let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage ? err.errorMessage : l.went_worng_pls_try_again;
            // console.log("msg ===== ", msg);
            toast.error(msg, {
                position: toast.POSITION.TOP_RIGHT
            })
            // console.log("err in get schedule === ", err);
            setSchedule({})
        })
    }, [])

    const handleSlideED = () => {
        setSlideED(prevState => !prevState);
    }
    const handleSlideD = () => {
        setSlideD(prevState => !prevState);
    }

    const handleDelete = () => {
        setSlideD(prevState => !prevState);
        deleteAllSch().then(res => {
            if (res && res.status) {
                loadSchedule();
            }
        }).catch(err => {
            toast.error('deleted successfully', {
                position: toast.POSITION.TOP_RIGHT
            })
        })
    }

    const handleNew = () => {
        setAddNew(prevState => !prevState);
        loadSchedule();
    }

    // const durationTime = [l.duration, "15 mins", "30 mins", "45 mins", "1 hour"]
    return <Fragment>
        {loading ? <Loader />
            : shedule && Object.keys(shedule).length > 0 ? <div className="tabContent">
                <div className="colBlock">
                    <div className="shedHdrBlock">
                        <div className="rowBlock">
                            <div className="btnTxtGroup flxEnd">
                                {/* <Button size="sm" className="btn" type="outLine" label="+ Add Another Schedule" />  */}
                                <button className="btnFilled sm" onClick={(e) => setAddNew(prevState => !prevState)}>
                                    <img src="/images/icons/create-schedule-outline.png" className="invertWhite" alt="icon" />
                                    <span>{l.create_sched}</span>
                                </button>
                                <button className="btnTxt sm" onClick={() => setDD(prevState => !prevState)}>
                                    <img src="/images/icons/no-schedule.png" alt="icon" className="invertPrimary" />
                                    <span>{l.disable_date}</span>
                                </button>
                                <button className="btnTxt sm" onClick={handleSlideD}>
                                    <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary"/>
                                    <span>{l.del_all}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="btnTxtGroup alignCenter justifyCenter">
                <Button size="sm" className="btn" type="outLine" label="+ Add Another Schedule" /> 
            </div> */}
                {Object.keys(shedule).map((sch, i) => <ScheduleListItem data={shedule[sch]} key={`${sch}_${i}`} reloadData={loadSchedule} />)}

            </div>
                : <CreateDays loadSch={loadSchedule} />}
        {openDD && <DisableDatesSlider open={openDD} handleClose={() => setDD(prevState => !prevState)} data={Object.values(shedule).flat(1)} />}
        {slideD && <BtmDeleteSlide slideD={slideD} handleCancel={() => setSlideD(prevState => !prevState)} txt={l.conf_del} handleConfirm={handleDelete} />}
        {slideED && <BtmEditDeletSlider slideED={slideED} handleSlideED={handleSlideED} />}
        {addNew && <AddNewSchedule open={addNew} handleClose={(e) => setAddNew(prevState => !prevState)} loadSch={handleNew} />}
    </Fragment>
}
export default CreateSchedule;



// {/* <div className="nodataBlock mrgnT">
//                     <div className="ndIconBox">
//                         <img src="/images/icons/no-schedule.png" alt="no-schedule-icon" />
//                     </div>
//                     <h2 className="nodataHdng">No Schedule</h2>
//                     <span className="txtMd txtCenter">Create new a schedule by selecting date and days, and add slots to them.</span>
//                 </div> */}